import { render, staticRenderFns } from "./indexbak.vue?vue&type=template&id=4002943a&scoped=true&"
import script from "./indexbak.vue?vue&type=script&lang=js&"
export * from "./indexbak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4002943a",
  null
  
)

export default component.exports